/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type VolunteerShiftSignupsQueryVariables = Types.Exact<{
  where: Types.ShiftSignupWhereInput;
}>;

export type VolunteerShiftSignupsQuery = {
  volunteerShiftSignups: Array<
    Pick<
      Types.ShiftSignup,
      "event_attendee_id" | "shift_id" | "checked_in" | "completed"
    > & {
      event_attendee: Pick<Types.EventAttendee, "id" | "role"> & {
        user: Pick<Types.User, "id" | "name" | "email">;
      };
    }
  >;
};

export const VolunteerShiftSignupsDocument = gql`
  query VolunteerShiftSignups($where: ShiftSignupWhereInput!) {
    volunteerShiftSignups(where: $where) {
      event_attendee_id
      shift_id
      checked_in
      completed
      event_attendee {
        id
        role
        user {
          id
          name
          email
        }
      }
    }
  }
`;

/**
 * __useVolunteerShiftSignupsQuery__
 *
 * To run a query within a React component, call `useVolunteerShiftSignupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerShiftSignupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerShiftSignupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVolunteerShiftSignupsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VolunteerShiftSignupsQuery,
    VolunteerShiftSignupsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    VolunteerShiftSignupsQuery,
    VolunteerShiftSignupsQueryVariables
  >(VolunteerShiftSignupsDocument, baseOptions);
}
export function useVolunteerShiftSignupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VolunteerShiftSignupsQuery,
    VolunteerShiftSignupsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    VolunteerShiftSignupsQuery,
    VolunteerShiftSignupsQueryVariables
  >(VolunteerShiftSignupsDocument, baseOptions);
}
export type VolunteerShiftSignupsQueryHookResult = ReturnType<
  typeof useVolunteerShiftSignupsQuery
>;
export type VolunteerShiftSignupsLazyQueryHookResult = ReturnType<
  typeof useVolunteerShiftSignupsLazyQuery
>;
export type VolunteerShiftSignupsQueryResult = ApolloReactCommon.QueryResult<
  VolunteerShiftSignupsQuery,
  VolunteerShiftSignupsQueryVariables
>;
